// extracted by mini-css-extract-plugin
export default {"root":"Chat_root__K5f9t","header":"Chat_header__hZnJz"};